import(/* webpackMode: "eager" */ "/opt/build/repo/app/auth/page.jsx");
